<template>
    <div
        class="inline-flex"
        :class="{ 'opacity-50': disabled }"
        role="radiogroup"
        aria-label="Lead time"
        @click.stop
    >
            <button
                v-for="(option, index) in options"
                :key="option.hours"
                type="button"
                role="radio"
                :aria-checked="isSelected(option.hours)"
                :aria-label="option.label"
                :disabled="disabled"
                :title="option.label"
                class="lead-time-segment font-semibold border border-gray focus:outline-none focus:ring-1 focus:ring-green disabled:cursor-not-allowed"
                :class="segmentClass(option.hours, index)"
                @click="select(option.hours)"
            >
                {{ option.shortLabel }}
            </button>
    </div>
</template>

<script>
const OPTIONS = [
    { hours: 24, shortLabel: '24h', label: '24 Hour Lead Time' },
    { hours: 48, shortLabel: '48h', label: '48 Hour Lead Time' },
    { hours: 72, shortLabel: '72h', label: '72 Hour Lead Time' },
];

export default {
    props: {
        modelValue: {
            type: [Number, String],
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    emits: ['update:modelValue'],

    data() {
        return {
            options: OPTIONS,
        };
    },

    methods: {
        isSelected(hours) {
            return Number(this.modelValue) === hours;
        },

        /**
         * Select a lead time. The current selection stays on.
         *
         * @param {number} hours
         */
        select(hours) {
            if (this.disabled || this.isSelected(hours)) {
                return;
            }

            this.$emit('update:modelValue', hours);
        },

        segmentClass(hours, index) {
            const selected = this.isSelected(hours);
            const edge = index === 0 ? 'rounded-l' : index === this.options.length - 1 ? 'rounded-r border-l-0' : 'border-l-0';

            if (selected) {
                return `bg-green text-white border-green ${edge}`;
            }

            return `bg-white text-gray-darker hover:bg-gray-light ${edge}`;
        },
    },
};
</script>

<style scoped>
.lead-time-segment {
    font-size: 0.8rem;
    line-height: 1rem;
    padding: 0.5rem 0.75rem;
}
</style>
